/**
 * Searchanise instant search shows raw Shopify prices. For product handles merged in the header
 * (shop metafield custom.km_lead_search_handles + optional collection + optional textarea),
 * replaces the price cell with the lead CTA label using theme .button styling.
 *
 * When the price node sits inside Searchanise’s product <a>, we inject a <span class="button"> to
 * avoid nested interactive elements; otherwise we use <a href="…">.
 *
 * Scoped to .snize-ac-results / .snize-ac-results-mobile only.
 */
(function () {
  var LABEL = typeof window.kmSearchaniseLeadPriceLabel === 'string' ? window.kmSearchaniseLeadPriceLabel : '';
  var rawHandles = Array.isArray(window.kmSearchaniseLeadHandles) ? window.kmSearchaniseLeadHandles : [];
  var HANDLES = new Set(rawHandles.map(function (h) {
    return String(h || '').toLowerCase().trim();
  }).filter(Boolean));

  if (!LABEL || !HANDLES.size) return;

  function handleFromHref(href) {
    if (!href) return null;
    try {
      var u = new URL(href, window.location.origin);
      var m = u.pathname.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]).toLowerCase() : null;
    } catch {
      return null;
    }
  }

  function matchesPatched(node, productHref) {
    if (!node || !node.classList || !node.classList.contains('km-snize-lead-cta')) return false;
    if (node.textContent !== LABEL) return false;
    if (node.tagName === 'A') return node.href === productHref;
    return true;
  }

  function replacePriceInRow(row, productHref) {
    row.querySelectorAll('.snize-price, [class*="snize-price"]').forEach(function (el) {
      var cur = el.querySelector('.km-snize-lead-cta');
      if (matchesPatched(cur, productHref)) return;

      var insideCardLink = !!(el.closest && el.closest('a[href*="/products/"]'));
      var node;
      if (insideCardLink) {
        node = document.createElement('span');
        node.className = 'button km-snize-lead-cta';
        node.textContent = LABEL;
      } else {
        node = document.createElement('a');
        node.className = 'button km-snize-lead-cta';
        node.href = productHref;
        node.textContent = LABEL;
      }
      el.replaceChildren(node);
    });
  }

  function patchBox(box) {
    if (!box.querySelectorAll) return;
    box.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var h = handleFromHref(a.getAttribute('href'));
      if (!h || !HANDLES.has(h)) return;
      var row = a.closest('li') || a.closest('.snize-ac-subcategory-item') || a.parentElement;
      if (!row) return;
      replacePriceInRow(row, a.href);
    });
  }

  function patchAll() {
    document.querySelectorAll('.snize-ac-results, .snize-ac-results-mobile').forEach(patchBox);
  }

  var raf = 0;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      patchAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
